/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareResponse,
    FirmwareResponseFromJSON,
    FirmwareResponseFromJSONTyped,
    FirmwareResponseToJSON,
} from './FirmwareResponse';

/**
 * 
 * @export
 * @interface FirmwaresResponse
 */
export interface FirmwaresResponse {
    /**
     * 
     * @type {Array<FirmwareResponse>}
     * @memberof FirmwaresResponse
     */
    elements: Array<FirmwareResponse>;
    /**
     * 
     * @type {number}
     * @memberof FirmwaresResponse
     */
    totalElementCount: number | null;
}

export function FirmwaresResponseFromJSON(json: any): FirmwaresResponse {
    return FirmwaresResponseFromJSONTyped(json, false);
}

export function FirmwaresResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwaresResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(FirmwareResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function FirmwaresResponseToJSON(value?: FirmwaresResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(FirmwareResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

